import { useEffect, useState } from "react";
import { Typography, CircularProgress, Box, Chip } from "@mui/material";
import MUIIconButton from "../../../Component/UI/MUIIconButton/MUIIconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import classes from "./Conversations.module.css";
import EmptyView from "../../../Component/EmptyView/EmptyView";
import api from "../../../BrandOnBoarding/api";

const statusColors = {
  COMPLETED: "green",
  RETRY: "red",
  DEFAULT: "#FCD34D",
};

export default function ConversationHistory({ transactionId, requestId, getConversationData }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const webSocketBaseURL = process.env.REACT_APP_ORCHESTRATOR_BASE_URL;

  const getConversationHistory = async () => {
    try {
      setLoading(true);

      const result = await api.get(`${webSocketBaseURL}/conversation/${transactionId}/${requestId}`)
      setData(result?.data || []);
    } catch (error) {
      console.error("Failed to fetch conversation history", error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    getConversationHistory();
  }, []);


  if (loading) {
    return (
      <Box display="flex" justifyContent="center" py={3}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (!data.length) {
    return <EmptyView message="No conversation history found." />;
  }
  const formatDateTime = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);

    return date.toLocaleString(undefined, {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  return (
    <Box display="flex" flexDirection="column" gap={1.5} >
      {data.map((item) => (

        <Box className={classes.historyCard}>
          <Box className={classes.historyRow}>
            {/* LEFT STRIP */}
            <Box
              style={{
                borderLeft: `4px solid ${statusColors[item.status] || statusColors.DEFAULT
                  }`,
              }}
            />

            {/* MAIN CONTENT */}
            <Box className={classes.historyContent}>
              <Box className={classes.historyHeader}>
                <Typography className={classes.category}>
                  {item.category}
                </Typography>
              </Box>
              
              <Box className={classes.contextRow}>
                <span>
                  <strong>Persona:</strong> {item.persona}
                </span>
              </Box>

              <Box className={classes.timeRow}>
                {formatDateTime(item?.created_at)}
              </Box>

            </Box>

            {/* ACTIONS */}
            <Box className={classes.actions}>
              <MUIIconButton size="small" onClick={() => getConversationData(item)}>
                <VisibilityOutlinedIcon fontSize="small" />
              </MUIIconButton>
              {/* <MUIIconButton size="small">
                <DeleteIcon fontSize="small" />
              </MUIIconButton> */}
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
}
